import { defineComponent, reactive, computed } from 'vue';
export default defineComponent({
    name: 'SimpleProgressBar',
    props: {
        currentValue: {
            type: Number,
            required: true,
            default: 0,
        },
        totalValue: {
            type: Number,
            required: true,
            default: 100,
        },
        size: {
            type: Object,
            default: () => ({ width: 436, height: 104 }),
        },
        unit: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            isOveruse: computed(() => props.currentValue > props.totalValue),
            usageValue: computed(() => Math.abs(props.totalValue - props.currentValue)),
            progressValue: computed(() => ((props.totalValue - props.currentValue) / props.totalValue < 0
                ? 0
                : (props.totalValue - props.currentValue) / props.totalValue) * 100),
        });
        const descriptionLabel = computed(() => (state.isOveruse ? 'over used' : 'available'));
        return {
            state,
            descriptionLabel,
        };
    },
});
